import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const style = document.createElement('style');
style.textContent = `
  /* Foco laranja para todos os inputs - EXCETO campos de login */
  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline:not(#login-container .MuiOutlinedInput-notchedOutline),
  .MuiSelect-root.Mui-focused .MuiOutlinedInput-notchedOutline:not(#login-container .MuiOutlinedInput-notchedOutline),
  .MuiTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline:not(#login-container .MuiOutlinedInput-notchedOutline),
  .MuiFormControl-root.Mui-focused .MuiOutlinedInput-notchedOutline:not(#login-container .MuiOutlinedInput-notchedOutline),
  div[role="combobox"].Mui-focused + fieldset:not(#login-container fieldset),
  .MuiOutlinedInput-root.Mui-focused:not(#login-container .MuiOutlinedInput-root) fieldset {
    border-color: #FF9600 !important;
    border-width: 2px !important;
  }
  
  /* Campos de login mantêm verde no foco */
  #login-container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
  #login-container .MuiTextField-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #03C407 !important;
    border-width: 2px !important;
  }
  
  /* Label do login também verde */
  #login-container .MuiInputLabel-root.Mui-focused,
  #login-container .MuiFormLabel-root.Mui-focused {
    color: #03C407 !important;
  }
  
  /* Foco no label - EXCETO login */
  .MuiInputLabel-root.Mui-focused:not(#login-container .MuiInputLabel-root),
  .MuiFormLabel-root.Mui-focused:not(#login-container .MuiFormLabel-root),
  .MuiInputLabel-underline.Mui-focused:not(#login-container .MuiInputLabel-underline) {
    color: #FF9600 !important;
  }
  
  /* Campos Select quando.focused */
  .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused,
  .MuiSelect-root.Mui-focused {
    box-shadow: 0 0 0 2px rgba(255, 150, 0, 0.2);
  }
  
  /* Cabeçalhos de tabela com fundo azul escuro e texto branco */
  .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root,
  table.MuiTableHead-root .MuiTableRow-root .MuiTableCell-root,
  .MuiTableHead-root .MuiTableCell-head {
    background-color: #0D47A1 !important;
    color: #FFFFFF !important;
    font-weight: 600 !important;
  }
  
  /* Para DataGrid e outras tabelas */
  .MuiDataGrid-columnHeaders,
  .MuiDataGrid-columnHeader {
    background-color: #0D47A1 !important;
    color: #FFFFFF !important;
  }
  
  /* Ordenação em tabelas */
  .MuiTableSortLabel-root.Mui-active {
    color: #FFFFFF !important;
  }
  .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon {
    color: #FFFFFF !important;
  }
  
  /* Fieldset do Select quando focado */
  .MuiOutlinedInput-root.Mui-focused fieldset,
  .MuiSelect-outlined.Mui-focused ~ fieldset {
    border-color: #FF9600 !important;
    border-width: 2px !important;
  }
  
  /* Chip de seleção quando nenhum item selecionado (0 de X) */
  .MuiChip-root.MuiChip-variantOutlined.MuiChip-colorDefault,
  .MuiChip-root.MuiChip-outlined.MuiChip-colorDefault,
  .MuiChip-root.MuiChip-variantOutlined.MuiChip-sizeSmall {
    border-color: #FF9600 !important;
    color: #FF9600 !important;
  }
  
  .MuiChip-root.MuiChip-variantOutlined.MuiChip-colorDefault .MuiChip-label,
  .MuiChip-root.MuiChip-outlined.MuiChip-colorDefault .MuiChip-label {
    color: #FF9600 !important;
  }
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);